import React, { useEffect, useState } from "react";
import CookieModal from "./CookieModal";

const Cookie = () => {
    const [visible, setVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);


    useEffect(() => {
        const consent = localStorage.getItem("cookieConsent");
        if (!consent) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        const allConsent = {
            preferences: true,
            advertisement: true,
            functional: true,
            analytics: true
        };
        localStorage.setItem("cookieConsent", "accepted");
        localStorage.setItem("cookieConsentDetails", JSON.stringify(allConsent));
        setVisible(false);
    };

    const handleReject = () => {
        const rejectedConsent = {
            preferences: false,
            advertisement: false,
            functional: false,
            analytics: false
        };
        localStorage.setItem("cookieConsent", "rejected");
        localStorage.setItem("cookieConsentDetails", JSON.stringify(rejectedConsent));
        setVisible(false);
    };
    const handleClose = () => {
        setShowModal(false)
    }

    // if (!visible) return null;


    return (
        <>
            <CookieModal showModal={showModal} handleClose={handleClose} setVisible={setVisible} />
            {
                visible ?
                    <div className="cookies_box">
                        <div className="cookie_content">
                            <div className="left_text">
                                <p>
                                    This website uses cookies to improve your experience. By clicking “Accept” you are agreeing to our{" "}
                                    <a href="javascript:void(0)" onClick={() => setShowModal(true)} rel="noopener noreferrer">
                                        Cookie Policy.
                                    </a>
                                </p>
                            </div>
                            <div className="cookie_btn">
                                <button className="btn btn_reject" onClick={handleReject}>
                                    Reject All
                                </button>
                                <button className="btn btn_accept" onClick={handleAccept}>
                                    Accept{" "}
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8.00004 1.3335C4.32671 1.3335 1.33337 4.32683 1.33337 8.00016C1.33337 11.6735 4.32671 14.6668 8.00004 14.6668C11.6734 14.6668 14.6667 11.6735 14.6667 8.00016C14.6667 4.32683 11.6734 1.3335 8.00004 1.3335ZM11.1867 6.46683L7.40671 10.2468C7.31337 10.3402 7.18671 10.3935 7.05337 10.3935C6.92004 10.3935 6.79337 10.3402 6.70004 10.2468L4.81337 8.36016C4.62004 8.16683 4.62004 7.84683 4.81337 7.6535C5.00671 7.46016 5.32671 7.46016 5.52004 7.6535L7.05337 9.18683L10.48 5.76016C10.6734 5.56683 10.9934 5.56683 11.1867 5.76016C11.38 5.9535 11.38 6.26683 11.1867 6.46683Z"
                                            fill="#171202"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
            }
        </>
    );
};

export default Cookie;
